import { useMemo } from 'react'

import { type CoreProduct } from '@flecto/types'

export function useBundlePrice(bundle: CoreProduct) {
  return useMemo(() => {
    const base =
      bundle.bundle_attributes?.bundle_items?.reduce((sum, b) => {
        const rule = b.item.pricing_rules?.[0]
        return sum + (rule?.price_cents ?? 0)
      }, 0) ?? 0

    if (!bundle.bundle_attributes?.apply_general_discount_to_bundle)
      return base

    const amt = bundle.bundle_attributes.apply_general_discount_amount ?? 0
    const type = bundle.bundle_attributes.apply_general_discount_type

    return type === 'discount_percentage'
      ? Math.round(base * (1 - amt / 100))
      : base - amt
  }, [bundle])
}
